import React from "react";
import { Box } from "@mui/material";

const BlueLine = ({ height = "40%", borderRadius = "2px", width = "2px", color = "#88e0f7ff", mt= 1, ...props }) => {
  return ( 
    <Box
      sx={{
        position: "relative",
        display: "inline-block",
        pl: 3,
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          mt: mt,
          width: width,           
          height: height,          
          backgroundColor: color,  
          borderRadius: borderRadius, 
        },
      }}
      {...props}
    />
  );
};

export default BlueLine;
